// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1EDpE","fadeIn":"Button_fadeIn__3KZ-r","fadeOut":"Button_fadeOut__3RsXz"};